<template>
  <v-dialog v-model="openDialog" max-width="500px">
    <v-card>
      <v-toolbar flat color="secondary">
        <v-toolbar-title class="text-white">
          {{ $t("labels.delete") }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="white" @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <p class="text-h6 mt-4">
          {{ $t("strings.delete-json-path-question") }}
        </p>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary darken-1" variant="text" @click="closeDialog">
          {{ $t("labels.cancel") }}
        </v-btn>
        <v-btn color="secondary darken-1" variant="text" @click="deleteConfirm">
          {{ $t("labels.delete") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DialogConfirmJsonpathDeletion",
  props: ["dialog"],
  data() {
    return {};
  },
  computed: {
    openDialog() {
      return this.dialog;
    },
  },
  methods: {
    deleteConfirm() {
      this.$emit("deleteConfirm", true);
      this.$emit("closeDialog");
    },
    closeDialog() {
      this.$emit("deleteConfirm", false);
      this.$emit("closeDialog");
    },
  },
};
</script>
